import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePageTitle } from '../context/PageTitleContext';
import { PUBLIC_ACTION_PLAN_LIST_PATH, PUBLIC_ACTION_PLAN_DETAIL_PREFIX } from '../constants/routes';

/**
 * Postavlja `document.title` sinhrono pre paint-a (useLayoutEffect).
 * @param {string} title - Naslov stranice za browser tab.
 */
export const useDocumentTitle = (title) => {
  useLayoutEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
};

/**
 * Fallback za page title na rutama koje ne koriste `usePageTitle` direktno.
 * Preskače akcioni-plan i profil rute (one već ažuriraju naslov).
 * @returns {void}
 */
export const useRouteTitle = () => {
  const location = useLocation();
  const { updateTitle } = usePageTitle();
  
  useLayoutEffect(() => {
    // Preskoči rute gde komponente već koriste usePageTitle
    if (
      location.pathname.startsWith(PUBLIC_ACTION_PLAN_DETAIL_PREFIX) ||
      location.pathname === PUBLIC_ACTION_PLAN_LIST_PATH ||
      location.pathname.startsWith('/profil')
    ) {
      return;
    }
    
    const routeTitles = {
      '/': { page: 'Партнерство за отворену управу - ОГП Портал', h1: 'Партнерство за отворену управу' },
      '/signin-oidc': { page: 'Пријава - Партнерство за отворену управу', h1: 'Пријава' },
      '/signout-callback-oidc': { page: 'Одјава - Партнерство за отворену управу', h1: 'Одјава' },
    };
    
    // Pronađi najbolje poklapanje za rutу
    const titleInfo = routeTitles[location.pathname] || { page: 'Партнерство за отворену управу - ОГП Портал', h1: 'Партнерство за отворену управу' };
    
    updateTitle(titleInfo.page, titleInfo.h1);
  }, [location.pathname, updateTitle]); // updateTitle je memoizovan sa useCallback, pa ne uzrokuje loop
};

